import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.5 23h-15A1.502 1.502 0 0 1 3 21.5v-18A1.502 1.502 0 0 1 4.5 2h15A1.501 1.501 0 0 1 21 3.5v18a1.502 1.502 0 0 1-1.5 1.5ZM4.5 3.5v18h15v-18h-15Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.75 14H15v1.5H6.75V14Zm0 3.75H12v1.5H6.75v-1.5Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }